import api from 'api';

export const loadFilterStatuses = api(
  'GET /api/partner-audiences/filters/filter-statuses'
);
export const loadAudiences = api(
  'GET /api/partner-audiences/filters/audiences'
);
export const loadPartners = api('GET /api/partner-audiences/filters/partners');
export const loadDataTypes = api(
  'GET /api/partner-audiences/filters/data-types'
);
export const loadAccounts = api('GET /api/partner-audiences/filters/accounts');
export const loadCreatedBy = api(
  'GET /api/partner-audiences/filters/created-by'
);

export const loadOwners = api('GET /api/partner-audiences/filters/owners');
export const loadApplications = api(
  'GET /api/partner-audiences/filters/applications'
);
